import React from "react";
import { PAGE_LAYOUT_CLASS } from "../layout/pageLayout";
import { useDesktopNav } from "./navigation/DesktopNavContext";
import { DesktopBackLink } from "./navigation/ScreenBackButton";
import "./CrewPilotFormShell.css";

export function CrewPilotFormShell({
  title,
  subtitle,
  onBack,
  backLabel,
  children,
}) {
  const desktopNav = useDesktopNav();
  return (
    <div className={`screen nx-screen ${PAGE_LAYOUT_CLASS.FORM}`}>

      {desktopNav && onBack ? (
        <DesktopBackLink onClick={onBack} label={backLabel || desktopNav.parentLabel || "Back"} />
      ) : null}

      <div className="cp-form-header">

        <h1 className="cp-form-title">
  {title}
</h1>

{subtitle && (
  <>
    <p className="cp-form-subtitle">
      {subtitle}
    </p>

    <p className="cp-form-required-note">
      * Indicates required information
    </p>
  </>
)}

      </div>

      <div className="cp-form-content">
        {children}
      </div>

    </div>
  );
}